import { Language, KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'
import { IconButton, Menu, MenuItem } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'
import { useApp } from '../hooks/useApp'
import { Safety } from '../classes/Safety'
import { callAxios } from '../hooks/useAxios'

export const LANGUAGES = ['fi', 'en']

/**
 * Stores the chosen UI language (and on the user's account when logged in), then reloads to apply it.
 */
export function changeLanguage(language: string, loggedIn: boolean): void {
  const old = Safety.get('language')
  Safety.set('language', language)
  if (old === language) {
    return
  }
  if (loggedIn) {
    callAxios({
      method: 'PATCH',
      url: '/auth/me',
    }, { language }).then(() => {
      window.location.reload()
    })
  } else {
    window.location.reload()
  }
}

interface LanguageSelectorProps {
  onSelect?: (language: string) => void
}

export function LanguageSelector(props: LanguageSelectorProps): React.ReactElement {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const app = useApp()

  const onClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const onClose = () => {
    setAnchorEl(null)
  }
  const onSelect = (language: string) => {
    if (props.onSelect) {
      props.onSelect(language)
      onClose()
      return
    }
    onClose()
    changeLanguage(language, !!app.user)
  }

  return (
    <Box data-cy="language-selector">
      <IconButton
        size="large"
        edge="end"
        aria-label="language-selector"
        data-cy="language-selector-icon"
        onClick={onClick}
        >
        <Language sx={{ fontSize: '2rem' }} />
        {open ? <KeyboardArrowUp/> : <KeyboardArrowDown/>}
      </IconButton>
      <Menu
        id="language-menu"
        aria-labelledby="language-selector"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          sx={{ width: '5rem', color: '#f0f0f0' }}
          data-cy="language-selector-EN"
          onClick={() => onSelect('en')}
        >
            EN
        </MenuItem>
        <MenuItem
          sx={{ width: '5rem', color: '#f0f0f0' }}
          data-cy="language-selector-FI"
          onClick={() => onSelect('fi')}
        >
            FI
        </MenuItem>
      </Menu>
    </Box>
  )
}
